    function moduleRun(bbConfig, $sessionStorage, halClient) {
        'ngInject';
    }
    export default moduleRun;
    
    
    


// WEBPACK FOOTER //
// ../src/public/main.run.js